import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

class AlertDialog extends React.Component {

  render() {
    if(!this.props.open){
      return (null);
    }
    let Messages = {
      "title":"エラー",
      "message": "処理の実行中にエラーが発生したため、続行できません。エラーメッセージを確認してください:"
    }
    if(this.props.isSuccess){
      Messages = {
        "title" : "完了",
        "message" : ""
      }
    }
    return (
      <div>
        <Dialog
          open={this.props.open}
          onClose={this.props.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{Messages.title}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <span>{Messages.message}</span><br/>
              {this.props.errorMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.handleClose} color="primary" autoFocus>
              ok
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default AlertDialog;
